import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  Box,
} from "@mui/material";

import CustomCheckbox from "../CustomCheckbox";
import BillingSkeleton from "./BillingSkeleton";
import NoData from "../NoData/NoData";
import invoices from "./data"; // ✅ your data file
import BillingHistoryTableRow from "./BillingHistoryTableRow";

const cellStyle = {
  padding: "10px 16px",
};

const BillingHistoryTabTable = ({ filter }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Apply filter based on tab
  const filteredData =
    filter === "all" ? invoices : invoices.filter((inv) => inv.status === filter);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, [filter]);

  const handleSelectAll = () => {
    if (selectedRows.length === filteredData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(filteredData.map((row) => row.id));
    }
  };

  const handleRowToggle = (id) => () => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const allSelected = selectedRows.length === filteredData.length;
  const someSelected = selectedRows.length > 0 && !allSelected;

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        className="showSummaryCs mt-24"
        sx={{ padding: "0px 0 12px 0" }}
      >
        <Box component="li" sx={{ listStyle: "none" }}>
          <Typography variant="body2">
            <Box
              component="span"
              fontWeight="400"
              sx={{
                fontSize: "16px",
                color: "#1A1F36",
                padding: "6px 16px 3px 0px",
              }}
            >
              Billing History
            </Box>
          </Typography>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "none",
          background: "transparent",
          marginBottom: "24px",
        }}
      >
        <Table
          size="small"
          sx={{ borderCollapse: "separate", borderSpacing: "0 5px" }}
        >
          <TableHead sx={{ backgroundColor: "#DFDFDF" }}>
            <TableRow>
              <TableCell
                sx={{
                  ...cellStyle,
                  border: "none",
                  minWidth: "50px",
                  maxWidth: "32px",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                }}
              >
                <CustomCheckbox
                  checked={allSelected}
                  indeterminate={someSelected}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262" }}>
                #
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Created on
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Invoice number
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262" }}>
                Description
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Transaction
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Status
              </TableCell>
              <TableCell sx={{ ...cellStyle, border: "none", color: "#626262", textAlign: "center" }}>
                Amount
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(3)].map((_, i) => <BillingSkeleton key={i} />)
            ) : filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center" sx={{ padding: "40px 16px" }}>
                  <NoData />
                </TableCell>
              </TableRow>
            ) : (
              filteredData.map((row) => (
                <BillingHistoryTableRow
                  key={row.id}
                  row={row}
                  isSelected={selectedRows.includes(row.id)}
                  onSelectToggle={handleRowToggle(row.id)}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default BillingHistoryTabTable;
